module.exports = __webpack_public_path__ + "img/contrato.e973595d.jpg";